<div class="d-flex flex-md-row flex-column-reverse">
    <div class="flex-grow-1">
        <div class="slide--left container-fluid container-xxl">
            <div class="d-flex align-items-center">
                <div class="col-12 col-md-6 d-flex flex-column gx-0 h-100 justify-content-center pb-0 pb-md-12">
                    <h2 class="fs-32 lh-48 text-primary fw-700 mb-5">{{ banner.title }}</h2>
                    <p class="mb-5 lh-29 flex-shrink-1 overflow-auto pe-4">{{ banner.description }}</p>
                    <app-button color="secondary" [url]="banner.buttonUrl">{{ banner.button }}</app-button>
                </div>
            </div>
        </div>
    </div>

    <div class="flex-grow-1">
        <div [class.extend-r]="fullwidth" class="h-100">
            <div class="img-wrapper overflow-hidden h-100">
                <img [src]="banner.image.url | size: 'm'" alt="{{ banner.title }}" />
            </div>
        </div>
    </div>
</div>
